import type { V2ParsedMessageContent } from "@/types/v2";

export function formatV2ResponseMessage(message: string): V2ParsedMessageContent {
  const data: V2ParsedMessageContent = {
    result: "",
    requiresInput: false,
  };

  if (message.startsWith("{")) {
    try {
      const parsed = JSON.parse(message) as V2ParsedMessageContent & { message?: string };
      if ((parsed && parsed?.result) || parsed?.message) {
        if (typeof parsed.result === "string") data.result = parsed.result;
        if ("message" in parsed && typeof parsed.message === "string")
          data.result = parsed.message;
        if (parsed.requiresInput === true) {
          const newData: V2ParsedMessageContent = {
            result: data.result,
            requiresInput: true,
            inputType: parsed.inputType,
            options: parsed.options,
          };
          return newData;
        }
      }
    } catch {
      return data;
    }
  } else {
    data.result = message;
  }

  return data;
}
